<template>
    <d-button :theme="theme" :disabled="disabled" @click="onClick">
      <i v-if="icon" class="material-icons">{{ icon }}</i>
      {{ label }}
    </d-button>
  </template>
  
  <script>
    export default {
    props: {
      label: String,
      icon: String,
      theme: String,
      disabled: Boolean
    },
    methods: {
      onClick(event) {
        this.$emit('click', event);
      }
    }
  };
  </script>